import styled from 'styled-components';

const Wrapper = styled.div`
  .react-datepicker {
    padding: 16px;
    padding: 16px 10px 0;
    border: none;
    background-color: ${(props) => props.theme.colors.widget_background};

    .react-datepicker__children-container {
      width: auto;
      margin: 0;
    }

    .react-datepicker__header {
      background-color: ${(props) => props.theme.colors.widget_background};
      border-bottom: none;

      .react-datepicker__current-month {
        color: ${(props) => props.theme.colors.text};
        margin-bottom: 5px;
      }

      .react-datepicker__navigation-icon {
        color: ${(props) => props.theme.colors.red};
      }
    }

    .react-datepicker__month {
      color: ${(props) => props.theme.colors.text};
    }

    .react-datepicker__month-container {
      /* border-right: 1px solid ${(props) => props.theme.colors.outline}; */
      &:last-child {
        border-right: none;
      }
    }

    .react-datepicker__day {
      color: ${(props) => props.theme.colors.inactive};
      width: 34px;
      border-radius: 12px;

      &.react-datepicker__day--selected {
        color: ${(props) => props.theme.colors.widget_background};
        background: ${(props) => props.theme.colors.main_cta};
      }
    }

    .react-datepicker__day-name {
      color: ${(props) => props.theme.colors.inactive};
      width: 34px;
      height: 24px;
    }

    .react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range {
      background: ${(props) => props.theme.colors.main_cta};
      opacity: 0.5;
    }

    .react-datepicker__day--range-start, .react-datepicker__day--range-end {
      opacity: 1;
    }
  }

  .react-datepicker__wrapper {
    background: ${(props) => props.theme.colors.widget_background};
    .react-datepicker__footer {
       padding: 16px 10px;
       display: flex;
       justify-content: flex-start;
       align-items: center;
       color: ${(props) => props.theme.colors.text};
    }
    .label {
      font: 12px "Noto Sans", sans-serif;
      color: ${(props) => props.theme.colors.inactive};
      white-space: nowrap;
    }
    .actions {
      display: flex;
      margin-left: auto;
      font-size: 13px;

      button:first-child {
        margin-right: 16px;
      }
    }
  }
`;

export default { Wrapper };
